import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import detletIcon from '../../images/icons/icon-trash.svg';
import greenCheckIcon from '../../images/icons/icon-green-check.svg';

import style from './File.module.css';

const File = React.memo(
  ({ clientId, handleSelectFile, maxFileSize = null, handleFileSizeOverMax = () => {} }) => {
    const inputFile = useRef(null);
    const [file, setFile] = useState();

    const parseInBase64 = newFile => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(newFile);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    };

    const handleUploadFile = event => {
      const newFile = event.target.files[0];
      if (maxFileSize !== null && newFile.size > maxFileSize) {
        handleFileSizeOverMax(newFile.size);
        return;
      }

      if (newFile != null) {
        parseInBase64(newFile).then(base64 => {
          const fileToUpload = {
            FileName: newFile.name,
            ContentType: newFile.type,
            Content: base64,
            Partition: clientId,
          };
          setFile(fileToUpload);

          handleSelectFile(fileToUpload);
        });
      }
    };

    const handleClickFile = () => {
      inputFile.current.click();
    };

    const handleRemoveDocument = () => {
      setFile(null);

      handleSelectFile(null);
    };

    return (
      <>
        {file && (
          <div className={style.files}>
            <div>
              <img className={style.check} src={greenCheckIcon} alt="" />
              {file.FileName}
            </div>
            <button
              type="button"
              className={style.deleteBtn}
              onClick={handleRemoveDocument}
            >
              <img src={detletIcon} alt="" />
            </button>
          </div>
        )}
        <button
          className={style.fileBtn}
          type="button"
          onClick={handleClickFile}
        >
          Select a File
        </button>
        <input
          ref={inputFile}
          style={{ display: 'none' }}
          type="file"
          name="file"
          id="file"
          onChange={handleUploadFile}
        />
      </>
    );
  },
);

File.propTypes = {
  clientId: PropTypes.string.isRequired,
  handleSelectFile: PropTypes.func.isRequired,
  handleFileSizeOverMax: PropTypes.func,
  maxFileSize: PropTypes.number,
};

export default File;
